import * as types from './mutation-types'

const mutations = {
    [types.SET_TOKEN] (state,v){
        state.token = v
    },
    [types.SET_USER_INFO] (state,v) {
        state.userInfo = v;
    },
    [types.LOGOUT] (state){
        state.userInfo = null
        state.token = ""
    }
}
export default mutations
